import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { initialEdiXmlTrackingState, initialEdiXmlTrackingStats } from "./ediXmlTracking.types";
import {
  CLEAR_EDI_XML_TRACKING_STATE,
  FETCH_EDI_XML_TRACKING_LIST_FAILED,
  FETCH_EDI_XML_TRACKING_LIST_PROGRESS,
  FETCH_EDI_XML_TRACKING_LIST_SUCCESS,
  FETCH_EDI_XML_TRACKING_STATS_FAILED,
  FETCH_EDI_XML_TRACKING_STATS_PROGRESS,
  FETCH_EDI_XML_TRACKING_STATS_SUCCESS,
} from "./ediXmlTrackingActions";
import { LoadState } from "../../constants/enums";

export const ediXmlTrackingReducer = (
  state: IStoreState["ediXmlTracking"] = initialEdiXmlTrackingState,
  action: any
) => {
  switch (action.type) {
    case FETCH_EDI_XML_TRACKING_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_EDI_XML_TRACKING_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = list;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_EDI_XML_TRACKING_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case CLEAR_EDI_XML_TRACKING_STATE: {
      return initialEdiXmlTrackingState;
    }
    case FETCH_EDI_XML_TRACKING_STATS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.statsLoading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_EDI_XML_TRACKING_STATS_SUCCESS: {
      const { stats } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.statsLoading = LoadState.Loaded;
        draftState.stats = stats;
      });
      return newState;
    }
    case FETCH_EDI_XML_TRACKING_STATS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.statsLoading = LoadState.Failed;
        draftState.stats = initialEdiXmlTrackingStats;
      });
      return newState;
    }
    default:
      return state;
  }
};
